import { createSlice } from '@reduxjs/toolkit'
import {
  cashoutThunk,
  getBetsHistoryThunk,
  getCurrenctGameStateThunk,
  getTopBets,
  nextLevelThunk,
  openedTileThunk,
  placeBetThunk
} from 'redux-store/thunk/towerGame.thunk'

const initialState = {
  betResponse: null,
  openedTileResponse: null,
  cashoutResponse: null,
  currentGameStateResponse: null,
  betHistoryResponse: { count: 0, rows: [] },
  // loader
  betResponseLoading: false,
  currenctGameStateLoading: false,
  betHistoryResponseLoading: false,
  nextLevelResponse: null,
  topBetsLoading: false,
  topBetsData: null
}

const {
  actions: { setPlacedBetsData, setUnfinishedBet, appendLocalBetHistory },
  reducer
} = createSlice({
  name: 'towerGame',
  initialState,
  reducers: {
    setPlacedBetsData: (state, { payload }) => {
      return {
        ...state,
        betHistoryData: [payload, ...state.betHistoryData]
      }
    },
    setUnfinishedBet: (state, { payload }) => {
      if (state.currentGameStateResponse) {
        state.currentGameStateResponse.hasUnfinishedGame = false
      }
    },
    // Fun/demo mode: session-only bet history (no API / DB)
    appendLocalBetHistory: (state, { payload }) => {
      if (!payload) return state
      const rows = [payload, ...(state.betHistoryResponse?.rows || [])]
      return {
        ...state,
        betHistoryResponse: {
          ...state.betHistoryResponse,
          count: rows.length,
          rows
        }
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBetsHistoryThunk.pending, (state, { payload }) => {
        return {
          ...state,
          betHistoryResponseLoading: true
        }
      })
      .addCase(getBetsHistoryThunk.fulfilled, (state, { payload }) => {
        return {
          ...state,
          betHistoryResponseLoading: false,
          betHistoryResponse: payload
        }
      })
      .addCase(getBetsHistoryThunk.rejected, (state, { payload }) => {
        return {
          ...state,
          betHistoryResponseLoading: false
        }
      })
      .addCase(getCurrenctGameStateThunk.pending, (state, { payload }) => {
        return {
          ...state,
          currenctGameStateLoading: true
        }
      })
      .addCase(getCurrenctGameStateThunk.fulfilled, (state, { payload }) => {
        return {
          ...state,
          currenctGameStateLoading: false,
          currentGameStateResponse: payload
        }
      })
      .addCase(getCurrenctGameStateThunk.rejected, (state, { payload }) => {
        return {
          ...state,
          currenctGameStateLoading: false
        }
      })
      .addCase(placeBetThunk.pending, (state, { payload }) => {
        return {
          ...state,
          betResponseLoading: true
        }
      })
      .addCase(placeBetThunk.fulfilled, (state, { payload }) => {
        return {
          ...state,
          betResponse: payload,
          betResponseLoading: false
        }
      })
      .addCase(placeBetThunk.rejected, (state, { payload }) => {
        return {
          ...state,
          betResponseLoading: false
        }
      })
      .addCase(openedTileThunk.fulfilled, (state, { payload }) => {
        return {
          ...state,
          ...(payload?.result && {
            betHistoryResponse: {
              ...state.betHistoryResponse,
              rows: [payload, ...state.betHistoryResponse.rows]
            }
          }),
          openedTileResponse: payload
        }
      })
      .addCase(cashoutThunk.fulfilled, (state, { payload }) => {
        return {
          ...state,
          cashoutResponse: payload,
          ...(payload?.result && {
            betHistoryResponse: {
              ...state.betHistoryResponse,
              rows: [payload, ...state.betHistoryResponse.rows]
            }
          })
        }
      })
      .addCase(nextLevelThunk.fulfilled, (state, { payload }) => {
        return {
          ...state,
          nextLevelResponse: payload
        }
      })
      .addCase(getTopBets.pending, (state, action) => {
        return {
          ...state,
          topBetsLoading: true
        }
      })
      .addCase(getTopBets.fulfilled, (state, action) => {
        return {
          ...state,
          topBetsData: action.payload,
          topBetsLoading: false
        }
      })
      .addCase(getTopBets.rejected, (state, action) => {
        return {
          ...state,
          topBetsData: [],
          topBetsLoading: false
        }
      })
  }
})

export default reducer
export { setPlacedBetsData, setUnfinishedBet, appendLocalBetHistory }
